import { makeStyles } from '@material-ui/core/styles';

const useKanbanCardStyles = makeStyles(theme => ({
  cardContentRoot: {
    padding: '8px !important',
    '&:last-child': {
      padding: '8px !important',
      paddingBottom: '8px !important',
    },
  },
  cardContainer: {
    width: '250px',
  },
  cardStyle: {
    border: '2px solid #A3A3A3',
    borderRadius: 14,
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    overflow: 'hidden',
    background: '#fff',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    marginBottom: 8,
    flexWrap: 'wrap',
  },
  // statusChipStyle: {
  //   background: statusColor,
  //   color: '#fff',
  //   height: 24,
  //   borderRadius: 12,
  //   fontWeight: 700,
  // },
  ribbonGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'nowrap',
  },
  ribbon: {
    display: 'flex',
    justifyContent: 'end',
    marginRight: '20px',
  },
  priority: {
    background: '#b71c1c',
    color: '#fff',
    borderRadius: 12,
    padding: '6px 10px',
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  contentStyle: {
    padding: '8px !important',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: '0.5rem',
    marginBottom: '0.25rem',
    fontWeight: 700,
    // color: '#666666',
  },
  metaRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
    color: '#666666',
    fontSize: '0.75rem',
  },
  indexBadge: {
    background: '#ffffff',
    fontWeight: 700,
    color: '#666666',
    fontSize: '16px',
    lineHeight: '16px',
  },
  ribbonHeader: {
    background: 'rgb(211, 47, 47)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '12px 12px 0px 0px',
    padding: '6px 10px',
    fontSize: '12px',
    lineHeight: 1,
    fontWeight: 700,
  },
  iconPlayStyle: {
    fontSize: 24,
    color: 'white',
    backgroundColor: '#FFC300',
    borderRadius: '50%',
    cursor: 'pointer',
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  dateContainer: {
    margin: '0 auto',
    color: '#666666',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 500,
  },
  cicleInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    lineHeight: '14px',
  },
  dateInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    lineHeight: '14px',
  },
  infoText: {
    color: '#858585',
    fontSize: 11,
    lineHeight: '15px',
  },
}));

export default useKanbanCardStyles;
